import { CreateWebhookRequest, UpdateWebhookRequest, Webhook } from '../../types';
import { del, emptyPost, get, post, put, throwHttpError } from './api';

export async function getWebhooks(
    organization_id: string,
    organization_key?: string,
) {
    const response = await fetch(`/api/webhooks/${organization_id}?${organization_key ? `organization_key=${organization_key}` : ''}`, get());
    if (!response.ok) {
        await throwHttpError('An error occurred while getting organization webhooks.', response);
    }
    return await (response.json() as Promise<Webhook[]>);
}

export async function createWebhook(
    amplitude_callsite: string,
    organization_id: string,
    webhook_details: CreateWebhookRequest,
    organization_key?: string,
) {
    const response = await fetch(`/api/webhooks/${organization_id}${organization_key ? `?organization_key=${organization_key}` : ''}`, post(webhook_details));
    if (!response.ok) {
        await throwHttpError('An error occurred while creating the webhook.', response);
    }

    return await (response.json() as Promise<Webhook>);
}

export async function updateWebhook(
    amplitude_callsite: string,
    organization_id: string,
    webhook_id: string,
    webhook_details: UpdateWebhookRequest,
    organization_key?: string,
) {
    const response = await fetch(`/api/webhooks/${organization_id}/${webhook_id}${organization_key ? `?organization_key=${organization_key}` : ''}`, put(webhook_details));
    if (!response.ok) {
        await throwHttpError('An error occurred while updating the webhook.', response);
    }

    return await (response.json() as Promise<Webhook>);
}

export async function deleteWebhook(
    amplitude_callsite: string,
    organization_id: string,
    webhook_id: string,
    organization_key?: string,
) {
    const response = await fetch(`/api/webhooks/${organization_id}/${webhook_id}${organization_key ? `?organization_key=${organization_key}` : ''}`, del());
    if (!response.ok) {
        await throwHttpError('An error occurred while deleting the webhook.', response);
    }
}

export async function testWebhook(
    webhook_id: string,
    organization_id: string,
    organization_key?: string,
) {
    const response = await fetch(`/api/webhooks/${organization_id}/test/${webhook_id}${organization_key ? `?organization_key=${organization_key}` : ''}`, emptyPost());
    if (!response.ok) {
        await throwHttpError('An error occurred while testing the webhook.', response);
    }
}